import _ from 'lodash';
import moment from 'moment';
import { getField, updateField } from 'vuex-map-fields';

import Permissions from 'mixins/Permissions';
const state = {
    id_proceso: '',
    fecha_proceso: '',
    slug_proceso: '',
    slug_estado:'',
    info_proceso: {
        cliente: {
            nombre: "",
            celular: "",
            email: ""
        },
        comprador: {
            nombre: "",
            tipo_documento: "",
            numero_documento: "",
            celular: "",
            email: "",
            ubicacion_name: "",
            direccion: "",
            runt: "",
            antecedentes: "",
            multas: "",
            vr_multas: 0,
            observaciones: ""
        },
        vendedor: {
            nombre: "",
            celular: "",
            email: ""
        },
        asesor: {
            nombre: "",
            celular: "",
            email: ""
        },
        canales: [],
        servicios: [],
        vehiculo: {
            precio_venta: 0
        },
        necesidad: {

        },
        precios: {}
    },
    step: {},
    tabs_status: [],
    selector_status: [],
    estado_principal: {},
    proceso: {},
    negocios: [],
    acciones: {
        notas: [],
        tareas: [],
        citas: [],
    },
    chequeo_card: {
        title: '',
        photo: '',
        selector: ''
    },
    historial: [],
    documentos: {},
    update: {
        id: '',
        nombre: '',
        apellido: '',
        celular: '',
        whatsapp: '',
        whatsapp_checked: false,
        email: '',
        ubicacion_id: '',
        ubicacion_name: ''
    }
};
const mutations = {
    updateField,
    updateConsignacion: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'consignacion';
        state.slug_estado = payload.estado_slug;
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.cliente},
            asesor: {...payload.asesor},
            vehiculo: payload.vehiculo,
            is_retoma: payload.retoma,
            retoma: payload.retoma === true ? {...payload.retoma_data} : null,

        }
        state.tabs_status = [...payload.tabs_status];
        state.estado_principal = payload.estado_principal;
        if(payload.first_time){
            state.step = {
                ...payload.step,
                ...payload.estado_principal
            };
        }
        //Remove from selector
        let newArray = _.remove(payload.tabs_status, (val, index) => index !== 0);
        if(Permissions.methods.$hasRole('Asesor')){
            newArray = _.remove(newArray, (val, index) => index !== 0);
            if(state.step.slug === 'cotizado'){
                state.step = {
                    slug: "avaluo",
                    label: "Avaluo"
                };
            }
        }
        state.selector_status = newArray;
        state.historial = [...payload.historial];
        state.documentos = payload.documentos;
        if(payload.archivo){
            state.proceso.inspeccion_legal.vehiculo.documentos = {
                ...state.proceso.inspeccion_legal.vehiculo.documentos,
                ...payload.proceso.inspeccion_legal.vehiculo.documentos
            }
        }else{
            state.proceso = {
                ...state.proceso,
                ...payload.proceso
            };
        }
        //Filter only by asesor
        state.acciones = payload.acciones;
        /**if(Permissions.methods.$hasRole('Asesor')){
            var {notas, tareas, citas} = payload.acciones;
            var notasAsesor = notas.filter(nota => nota.id_usuario === Permissions.methods.$getIdUser());
            var tareasAsesor = tareas.filter(tarea => tarea.id_usuario === Permissions.methods.$getIdUser());
            var citasAsesor = citas.filter(cita => cita.id_usuario === Permissions.methods.$getIdUser());
            state.acciones = {notas: notasAsesor, tareas: tareasAsesor,citas: citasAsesor}
        }else{
            state.acciones = payload.acciones;
        }**/
        if(state.proceso.avaluo.estado === 'avaluo_local'){
            state.proceso.cotizado = {
                ...state.proceso.cotizado,
                avaluo: state.proceso.avaluo.cotizacion
            }
        }
        if(state.proceso.avaluo.estado === 'cotizado'){
            var precio_vehiculo = state.info_proceso.vehiculo.precio_publicacion;
            var precio_publicacion = state.proceso.avaluo.avaluoForm.precio_publicacion_final;
            state.proceso.avaluo.avaluoForm.precio_publicacion_final = precio_publicacion === 0 ? state.proceso.avaluo.cotizacion.vr_publicado : precio_vehiculo;
        }

        if(state.proceso.inspeccion_mecanica.inspeccion.estado === 'encuesta'){
            state.proceso.inspeccion_mecanica = {
                ...state.proceso.inspeccion_mecanica,
                inspeccion_resultado: payload.inspeccion?.proceso
            }
        }
        if(payload.oferta) {
            state.proceso.avaluo.avaluoForm.oferta = payload.proceso.avaluo.avaluoForm.oferta;
        }
        if(!payload.proceso.avaluo.avaluoForm.oferta) {
            state.proceso.avaluo.avaluoForm.oferta = {
                id: '',
                precio_oferta: 0,
                ofertaImgs: []
            }
        }
        //Fields from other forms
        state.proceso.inspeccion_legal.vehiculo.marca = payload.proceso.inspeccion_legal.vehiculo.marca ?? state.info_proceso.vehiculo.marca ?? 'No registrada';
        state.proceso.inspeccion_legal.vehiculo.modelo = payload.proceso.inspeccion_legal.vehiculo.modelo ?? state.info_proceso.vehiculo.modelo ?? 'No registrada';
        state.proceso.inspeccion_legal.vehiculo.linea = payload.proceso.inspeccion_legal.vehiculo.linea ?? state.info_proceso.vehiculo.linea ?? 'No registrada';
        state.proceso.inspeccion_legal.vehiculo.cilindraje = payload.proceso.inspeccion_legal.vehiculo.cilindraje ?? state.info_proceso.vehiculo.meta_keys.clindraje ?? 0;
        state.proceso.inspeccion_legal.vehiculo.kilometraje = state.info_proceso.vehiculo.kilometraje;
        state.proceso.inspeccion_legal.vehiculo.color_primario = state.info_proceso.vehiculo.color;
        state.proceso.inspeccion_legal.vehiculo.garantias_favor = payload.proceso.inspeccion_legal.vehiculo.garantias_favor ?? [];
        state.proceso.inspeccion_legal.vehiculo.garantias_mobiliarias = payload.proceso.inspeccion_legal.vehiculo.garantias_mobiliarias ?? [];
        state.proceso.inspeccion_legal.vehiculo.limitaciones = payload.proceso.inspeccion_legal.vehiculo.limitaciones ?? [];
    },
    updateConsignacionDepreciacion: (state, payload) => {
        state.proceso.cotizar.cotizacionForm = {
            ...state.proceso.cotizar.cotizacionForm,
            vr_depreciacion: payload
        };
    },
    updateConsignacionLimitaciones: (state, payload) => {
        state.proceso.inspeccion_legal.vehiculo = {
            ...state.proceso.inspeccion_legal.vehiculo,
            garantias_favor: payload.garantias_favor,
            garantias_mobiliarias: payload.garantias_mobiliarias,
            limitaciones: payload.limitaciones
        };
    },
    updateVenta: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'venta';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.cliente},
            asesor: {...payload.asesor},
            necesidad: {...payload.identificacion_necesidad},
            canales: [...payload.canales]
        }
        state.historial = [...payload.historial];
        state.negocios = [...payload.negocios];
        state.documentos = payload.documentos;
        state.acciones = payload.acciones;

    },
    updateCredito: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'credito';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.cliente},
            asesor: {...payload.asesor}
        }
        state.tabs_status = payload.tabs_status;
        state.step = {
            ...payload.step,
            ...payload.estado_principal
        };
        state.selector_status = payload.tabs_status;
        state.historial = payload.historial;
        state.procesos = payload.procesos;
        state.documentos = payload.documentos;
        state.acciones = payload.acciones;
    },
    updateInspeccion: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'inspeccion';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.cliente},
            asesor: {...payload.asesor},
            vehiculo: payload.vehiculo
        }
        var tabs_status = [...payload.tabs_status];
        var newTabs = [];
        if(payload.tipo_inspeccion === 'basica') {
            var tabAccesorios = tabs_status.find(item => item.slug === 'accesorios' );
            var tabFotos = tabs_status.find(item => item.slug === 'fotos' );
            var tabEncuesta = tabs_status.find(item => item.slug === 'encuesta' );
            newTabs.push(tabAccesorios, tabFotos, tabEncuesta);
            state.tabs_status = newTabs;
        }else {
            state.tabs_status = [...payload.tabs_status];
        }
        //Remove from selector
        if(payload.first_time){
            state.step = {
                ...payload.step,
                ...payload.estado_principal
            };
        }
        state.historial = [...payload.historial];
        //state.acciones = payload.acciones;
        //state.documentos = payload.documentos;
        state.proceso = {
            ...state.proceso,
            ...payload.proceso
        };
    },
    updateInventario: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'inventario';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.cliente},
            asesor: {...payload.asesor},
            vehiculo: payload.vehiculo,
            isNew: payload.is_new,
            motivo: payload.motivo,
            fecha: payload.fecha
        }
        state.historial = [...payload.historial];
        state.proceso = {
            ...state.proceso,
            ...payload.proceso
        };
    },
    updateAdminVenta: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'adminventa';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.format_date = payload.format_date;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...payload.vendedor},
            asesor: {...payload.asesor},
            comprador: {...payload.comprador},
            vendedor: {...payload.vendedor},
            canales: payload.canales,
            vehiculo: payload.vehiculo,
            recaudo_total: payload.recaudo_total,
            pagar_total: payload.pagar_total,
            liquidacion : payload.proceso.tramite.gastos_traspaso.liquidacion,
            is_retoma: payload.is_retoma,
            precios: payload.vehiculo.resumen_negocio,
            sede_consignacion_name: payload.sede_consignacion,
            sede_venta_name: payload.sede_venta
        },
        state.tabs_status = [...payload.tabs_status];
        state.estado_principal = payload.estado_principal;

        state.step = {
            ...payload.step,
            ...payload.estado_principal
        };
        state.facturacion = payload.facturacion;
        state.selector_status = payload.tabs_status;
        state.historial = [ ...payload.historial ];
        state.acciones = payload.acciones;
        state.documentos = payload.documentos;
        var soportes_recaudo_comprador = payload.soportes_data.recaudo.soportes_comprador;
        var soportes_pago_comprador = payload.soportes_data.pago.soportes_comprador;

        var soportes_recaudo_vendedor = payload.soportes_data.recaudo.soportes_vendedor
        var soportes_pago_vendedor = payload.soportes_data.pago.soportes_vendedor;

        state.soporte = {
            ...state.soporte,
            recaudo: soportes_recaudo_comprador.concat(soportes_pago_comprador),
            pago: soportes_recaudo_vendedor.concat(soportes_pago_vendedor)
        };

        if(payload.archivo){
            state.documentos = {
                ...state.documentos,
                ...payload.documentos
            }
        }else{
            state.proceso = {
                ...state.proceso,
                ...payload.proceso
            };
        }
        state.proceso.cierre.comprador.datos_personales = payload.comprador;
        state.proceso.cierre.vendedor.datos_personales = payload.vendedor;

        state.consignacion = payload.consignacion;
    },
    updateRetoma: (state, payload) => {
        state.id_proceso = payload._id;
        state.slug_proceso = 'retomas';
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            asesor: {...payload.asesor},
            vehiculo: payload.vehiculo
        }
        state.tabs_status = [...payload.tabs_status];
        state.estado_principal = payload.estado_principal;
        state.inversionistas = {...payload.inversionistas};
        state.historial = [...payload.historial];
        state.documentos = payload.documentos;
        state.vendedor = payload.vendedor;
        state.proceso = {
            ...state.proceso,
            ...payload.proceso
        };
        state.acciones = payload.acciones;
        console.log('updateRetoma', payload);
    },
    updateSidebar: (state, payload) => {
        /**if(Permissions.methods.$hasRole('Asesor')){
            var {notas, tareas, citas} = payload.acciones;
            var notasAsesor = notas.filter(nota => nota.id_usuario === Permissions.methods.$getIdUser());
            var tareasAsesor = tareas.filter(tarea => tarea.id_usuario === Permissions.methods.$getIdUser());
            var citasAsesor = citas.filter(cita => cita.id_usuario === Permissions.methods.$getIdUser());
            state.acciones = {notas: notasAsesor, tareas: tareasAsesor,citas: citasAsesor}
        }else{
            state.acciones = payload.acciones;
        }**/
        state.acciones = payload.acciones;
        state.documentos = payload.documentos;
    },
    updateServicio: (state, payload) => {
        var {servicio, venta} = payload;
        state.id_proceso = venta._id;
        state.slug_proceso = 'servicio';
        var createdFormat = moment(venta.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: {...venta.cliente},
            asesor: {...venta.asesor},
            necesidad: {...venta.identificacion_necesidad},
        }
        if(servicio.tipo === 'comprar_vehiculo'){
            var { negocio } = servicio;
            state.historial = [...venta.historial];
            //Selector
            state.tabs_status = negocio.tabs_status;
            state.selector_status = negocio.tabs_status;
            state.estado_principal = negocio.estado_principal;
            state.step = {
                ...payload.step,
                ...negocio.estado_principal
            };
            //Actualizar procesos
            /**state.info_proceso = {
                ...state.info_proceso
            }**/
            state.proceso = {
                ...state.proceso,
                ...negocio.proceso
            };
        }else{
            //state.historial = [...venta.historial];
        }

        //state.negocios = [...payload.negocios];
        //state.documentos = payload.documentos;
        //state.acciones = payload.acciones;
    },
    updateChequeoCard: (state, payload) => {
        state.chequeo_card = {...state.chequeo_card, ...payload};
    },
    updateStep: (state, payload) => {
        state.step = {...state.step, ...payload};
    },

    addItems: (state, payload) => {
        state.proceso.tramite.gastos_traspaso.newItems.push(payload);
    },
    removeItems: (state, payload) => {
        state.proceso.tramite.gastos_traspaso.newItems.splice(payload, 1);
    },
    saveItems: (state, payload) => {
        state.proceso.tramite.gastos_traspaso.newItems = payload;
    },
    addImpuestos: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.impuestos.push(payload);
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.impuestos.push(payload);
        }
    },
    removeImpuestos: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.impuestos.splice(payload, 1);
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.impuestos.splice(payload, 1);
        }
    },
    saveImpuestos: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.impuestos = payload;
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.impuestos = payload;
        }
    },
    addMultas: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.multas.push(payload);
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.multas.push(payload);
        }
    },
    removeMultas: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.multas.splice(payload, 1);
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.multas.splice(payload, 1);
        }
    },
    saveMultas: (state, payload) => {
        if(state.slug_proceso == 'adminventa') {
            state.proceso.tramite.gastos_traspaso.multas = payload;
        }else {
            state.proceso.inspeccion_legal.gastos_traspaso.multas = payload;
        }
    },
    updateAdminVentaComprador: (state, payload) => {
        state.update.id = payload.id;
        state.update.nombre = payload.nombre ? payload.nombre : '';
        state.update.apellido = payload.apellido ? payload.apellido : '';
        state.update.celular = payload.celular ? payload.celular : '';
        state.update.whatsapp = payload.whatsapp ? payload.whatsapp : '';
        state.update.whatsapp_checked = payload.whatsapp_checked ? payload.whatsapp_checked : false;
        state.update.email = payload.email ? payload.email : '';
        state.update.ubicacion_id = payload.ubicacion_id ? payload.ubicacion_id : '';
        state.update.ubicacion_name = payload.ubicacion_name ? payload.ubicacion_name : '';
    },
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
